module.exports = __webpack_public_path__ + "static/media/sub-card-label-10.278880ba.svg";